
    import {PageRequest} from '@/store/shared/entity'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins,appConst } from "@/lib";

    class  PageContainerShipmentStatisticsRequest extends PageRequest{
        shipmentDate:[];
        chargeUserId:number;
        businessGroup:string;
        customerId:number;
        logisticsId:number;
        senderId:number;
    }

    @Component({
 name: "containershipmentstatistics",
        components:{}
    })
    export default class ContainerShipmentStatistics extends  Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageContainerShipmentStatisticsRequest(),
            queryAction:"counterstatistics/containershipmentstatistics/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                 
                { title:this.L('app.ContainerShipmentStatistics.LogisticsName'), key:'logisticsName' ,minWidth: 500},
                { title:this.L('app.ContainerShipmentStatistics._40HQ'), key:'_40HQ' ,minWidth: 100},
                { title:this.L('app.ContainerShipmentStatistics._40GP'), key:'_40GP' ,minWidth: 100},
                { title:this.L('app.ContainerShipmentStatistics._20GP'), key:'_20GP' ,minWidth: 100},
                { title:this.L('app.ContainerShipmentStatistics._45HQ'), key:'_45HQ' ,minWidth: 100},
                {
                  title: this.L("app.ContainerShipmentStatistics.WholeCabinetStatistics"),
                  key: "wholeCabinetStatistics",
                  minWidth: 100
               },  
                // { title:this.L('app.ContainerShipmentStatistics.WholeCabinetStatistics'), key:'_45HQ' },
              
            ]
        }

        get userList() {
         return this.$store.state.system.userassignment.userList;
        }   
  // 当前人负责的业务组
  get businessGroupOfCurrentUser() {
    return this.$store.state.system.user.businessGroup;
  }
//客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }
  get logisticsList() {
    return this.$store.state.system.logistics.logisticsIdList;
  }
  get senderList() {
    return this.$store.state.system.sender.senderList;
  }

  // 业务组列表
    get businessGroupList() {
      return this.getCodeListByCategory(appConst.codeCategory.businessGroup)
    }
        reset(){
            this.data.model = new PageContainerShipmentStatisticsRequest();
            // 不是业务组负责人，则默认查询单证为当前人
            if (!this.businessGroupOfCurrentUser) {
                if (this.userList && this.userList.findIndex(item => item.value === this.currentUser.id) > -1) {
                    this.$set(this.data.model, "chargeUserId", this.currentUser.id);
                }
            } else {
                if (this.businessGroupList && this.businessGroupList.findIndex(item => item.value === this.businessGroupOfCurrentUser) > -1) {
                    this.$set(this.data.model, "businessGroup", this.businessGroupOfCurrentUser);
                }
            }
        }
        async created(){
            await this.$store.dispatch("system/logistics/getLogisticsIdOption");
            // 不是业务组负责人，则默认查询单证为当前人
            if (!this.businessGroupOfCurrentUser) {
                if (this.userList && this.userList.findIndex(item => item.value === this.currentUser.id) > -1) {
                    this.$set(this.data.model, "chargeUserId", this.currentUser.id);
                }
            } else {
                if (this.businessGroupList && this.businessGroupList.findIndex(item => item.value === this.businessGroupOfCurrentUser) > -1) {
                    this.$set(this.data.model, "businessGroup", this.businessGroupOfCurrentUser);
                }
            }
             await this.$store.dispatch({
                 type:'system/userassignment/getUser'
             })
             
          
           }
  
    summaryMethod({ columns, data }) {
        const sums = {};
        const totalText = this.L('app.AmountStatistics.AllRecordsTotal');
        const NA = 'N/A';
        columns.forEach((column, index) => {
            const key = column.key;
            if (index === 0 ) {
                sums[key] = {
                    key,
                    value: ''
                };
                return;
            }
            if (index === 1) {
                sums[key] = {
                    key,
                    value: totalText
                };
                return;
            }
            if(index===2){
                sums[key] = {
                    key,
                    value: data[0].total40HQ
                };
                return;
            }
            if(index===3){
                sums[key] = {
                    key,
                    value: data[0].total40GP
                };
                return;
            }
            if(index===4){
                sums[key] = {
                    key,
                    value: data[0].total20GP
                };
                return;
            }
            if(index===5){
                sums[key] = {
                    key,
                    value: data[0].total45HQ
                };
                return;
            }
            if(index===6){
                sums[key] = {
                    key,
                    value: data[0].totalWholeCabinetStatistics
                };
                return;
            }
            const values = data.map(item => Number(item[key]));
            if (!values.every(value => isNaN(value))) {
                const v = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0);
                sums[key] = {
                    key,
                    value: v
                };
            } else {
                sums[key] = {
                    key,
                    value: NA
                };
            }
        });

        return sums;
    }
     totalLCL(){
         let tt=this.$store.state.counterstatistics.containershipmentstatistics.totalLCL
             tt=this.$util.format.amount(tt);
            return  tt;
    }
    get  currentUser() {
    return this.$store.state.currentUser.session.user;
  }
}
